import { render, staticRenderFns } from "./SupplyAssessment.vue?vue&type=template&id=08370ef6&scoped=true&"
import script from "./SupplyAssessment.vue?vue&type=script&lang=js&"
export * from "./SupplyAssessment.vue?vue&type=script&lang=js&"
import style0 from "./SupplyAssessment.vue?vue&type=style&index=0&id=08370ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08370ef6",
  null
  
)

export default component.exports